import DiagramType from "@core/components/Diagram/DiagramType";

export const COMMENT_INLINE_NODE_TYPES = ["inlineMd_component", "icon", "inlineImage"];
export const COMMENT_BLOCK_NODE_TYPES = [
	"image",
	"code_block",
	"note",
	"diagrams",
	"drawio",
	"video",
	"openapi",
	"fragment",
	"html",
	"view",
	...Object.keys(DiagramType),
];

export const COMMENT_NODE_TYPES = [...COMMENT_BLOCK_NODE_TYPES, ...COMMENT_INLINE_NODE_TYPES];

/** Token names as the tokenizer emits them: a code block arrives as a `fence`. */
export const COMMENT_TOKEN_TYPES = [...COMMENT_NODE_TYPES, "fence"];
